var map = {
	"./history.png": "59f9",
	"./limited.png": "2a3e",
	"./limited@2x.png": "7f83",
	"./on_hand.png": "98fd",
	"./on_hand@2x.png": "0589",
	"./permanent.png": "34ef",
	"./permanent@2x.png": "2150",
	"./unknown.png": "82bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8386";